import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Image from "../../../../../../components/ZUILib/Image";
import Link from "../../../../../../components/ZUILib/Link";
import Warning from "../../../../../../components/Warning";
import ModalPopover from "./../../../../../../components/ZUILib/ModalPopover";
import InputButton from "../../../../../../components/ZUILib/InputButton";
import ProgressBar from "../../../../../../components/ZUILib/ProgressBar";
import commonUtil from "../../../../../../utils/commonUtil";

import * as defaultConst from "../../../../../../utils/clientConstant";
import * as giftListActions from "../../actions";

const {
  getMessagesService,
  addAgainGiftItem,
  addThankYouMessage,
  getTrackOrder,
  getRegisteredGiftList,
} = giftListActions;
const eventTypes = [
  defaultConst.eventType.Aniversario,
  defaultConst.eventType.Cumpleanos,
  defaultConst.eventType.Despedida,
  defaultConst.eventType.Fiesta_Infantil,
  defaultConst.eventType.Fiesta_Reunion,
  defaultConst.eventType.Open_House,
  defaultConst.eventType.Others,
  defaultConst.eventType.Mascotas,
];

class ProductDetailsRecibidos extends Component {
  constructor(props) {
    super(props);
    this.state = {
      messageType: "",
    };
  }
  selectedProduct = this.props.selectedProduct;
  stage1class = "titleOrder";
  stage2class = "titleOrder";
  stage3class = "titleOrder";
  stage4class = "titleOrder";

  UNSAFE_componentWillMount() {
    this.props.getMessagesService(
      this.props.eventId,
      this.selectedProduct.purchaseItemId
    );
  }

  addAgain = (skuId) => {
    addAgainGiftItem(this.props.eventId, skuId)
      .then((response) => {
        if (response.body.status?.status === "success") {
          this.props.getRegisteredGiftList(this.props.eventId, "", "", "");
          this.warning.setMessage(
            commonUtil.getLabel(
              this.props.lables.EventAdminPage,
              "adminpage.regalosrecibidos.gift.added.success.message"
            )
          );
        } else {
          this.errorMessage.setMessage(
            commonUtil.getLabel(
              this.props.lables.EventAdminPage,
              "adminpage.regalosrecibidos.add.again.failure.message"
            )
          );
        }
      })
      .catch((e) => {
        console.log(e);
      }); // console required
  };
  sendThankyouMessage = (purchaseItemId) => {
    const message = document.getElementById("sendMessage").value;
    const guestemail =
      document.getElementById("guestemail") &&
      document.getElementById("guestemail").value;
    addThankYouMessage(
      this.props.eventId,
      purchaseItemId,
      message,
      guestemail || ""
    ).then((response) => {
      if (response.body.status === "success") {
        this.props.getRecievedGiftList(
          "",
          this.props.sortingValue,
          this.props.filterParameter
        );
        document.getElementById("sendMessage").value = "";
        if (document.getElementById("guestname"))
          document.getElementById("guestname").value = "";
        if (document.getElementById("guestemail"))
          document.getElementById("guestemail").value = "";
        this.selectedProduct.messageInfo = "replied";
        this.props.getMessagesService(
          this.props.eventId,
          this.selectedProduct.purchaseItemId
        );
        // this.setState({ ...this.state });
      }
      this.sendMessageModal.handleHide();
    });
  };
  trackOrder = (giftDetail) => {
    this.props
      .getTrackOrder(
        this.props.eventId,
        giftDetail.purchaseItemId,
        giftDetail.pedidoNo
      )
      .then((response) => {
        if (response.status === "success") {
          this.trackingModal.handleShow();
          // this.trackingFailureModal.handleShow();
        } else {
          this.trackingFailureModal.handleShow();
        }
      });
  };
  confirmAction = () => {
    this.trackingFailureModal.handleHide();
  };
  closeTrackModal = () => {
    this.trackingModal.handleHide();
  };

  showSendMessageModal = () => {
    this.sendMessageModal.handleShow();
  };
  closeSendMessageModal = () => {
    this.sendMessageModal.handleHide();
    document.getElementById("sendMessage").value = "";
    if (document.getElementById("guestname"))
      document.getElementById("guestname").value = "";
    if (document.getElementById("guestemail"))
      document.getElementById("guestemail").value = "";
  };
  messageLengthValidation = (e) => {
    // if (commonUtil.validateLength(e.target.value.length, 5)) {
    //   e.target.value = e.target.value.slice(0, 4);
    // }
    if (e.target.value.length >= 300 && e.keyCode !== 8) {
      e.target.value = e.target.value.slice(0, 300);
      // event.preventDefault();
      // return false;
    }

    // const sstr = e.target.value.split(' ');
    // let counter = 0;
    // const str = [];
    // sstr.forEach((item) => {
    //   counter += counter;
    //   if (!(counter >= +(5))) {
    //     str.push(item);
    //   }
    // });
    // const strnew = str.join(' ');
    // e.target.value = strnew;
    // return strnew + '...';

    // return true;
  };

  render() {
    const { lables } = this.props;

    // Modal data for tracker
    const modalButton = (
      <a
        className="status"
        onClick={() => this.trackOrder(this.selectedProduct)}
      >
        {this.selectedProduct.deliveryStatus}
      </a>
    );
    const modalHeaderForTracker = (
      <div className="row">
        <div className="col-xs-9">
          {" "}
          <span className="titleOptionModal">
            {commonUtil.getLabel(
              lables.EventAdminPage,
              "adminpage.regalosrecibidos.trackorder.popup.label"
            )}
          </span>
        </div>
        <div
          className="col-xs-3 text-right closeOptionModal"
          onClick={this.closeTrackModal}
        >
          {commonUtil.getLabel(
            lables.EventAdminPage,
            "adminpage.regalosrecibidos.cerrar.label"
          )}
          <span className="iClass icon-cerrar" aria-hidden="true" />
        </div>
      </div>
    );

    const SendMessageButton = {
      type: "button",
      value: commonUtil.getLabel(
        lables.EventAdminPage,
        "adminpage.regalosrecibidos.sendthankyou.button"
      ),
      autoFocus: false,
      style: "btnWhiteBlack",
      onClickHandler: this.showSendMessageModal,
      disabled: this.props.compareEventStatus(
        this.props.eventStatus,
        defaultConst.eventStatus.SUSPENDED
      )
        ? "disabled"
        : "",
    };
    // Modal data for Send Message
    const modalDataForSendMessage = (
      <InputButton buttonAttr={SendMessageButton} />
    );
    const modalHeaderForSendMessage = (
      <React.Fragment>
        {" "}
        <div className="modal-header--closeBtn">
          <p>
            {commonUtil.getLabel(
              lables.EventAdminPage,
              "adminpage.regalosrecibidos.cerrar.label"
            )}
          </p>
          <button className="close" type="button" aria-label="Close">
            <span aria-hidden="true" onClick={this.closeSendMessageModal}>
              ×
            </span>
          </button>
        </div>
        <h4 className="modal-title" id="myModalLabel">
          {commonUtil.getLabel(
            lables.EventAdminPage,
            "adminpage.regalosrecibidos.thankyoumsg.label"
          )}
        </h4>
      </React.Fragment>
    );
    /* Image for Tracker */
    const _imgsrcTracker = [
      {
        srcSet: this.selectedProduct.imageURL,
      },
    ];
    const imageAttrTracker = {
      id: "img1",
      src: this.selectedProduct.imageURL,
      className: "thumb",
      width: "100%",
      altImg: commonUtil.getAssetURL() + "/images/guest/no-image.png",
    };
    const SendThankYouMessage = {
      type: "button",
      value: commonUtil.getLabel(
        lables.EventAdminPage,
        "adminpage.regalosrecibidos.sendthankyou.button"
      ),
      autoFocus: false,
      style: "btnSecondarySpecial size-Full",
      onClickHandler: () =>
        this.sendThankyouMessage(this.selectedProduct.purchaseItemId),
    };
    const LinkJSON = {
      href: "javascript:void(0)",
      displayName: commonUtil.getLabel(
        lables.EventAdminPage,
        "adminpage.regalosrecibidos.addagain.label"
      ),
      onClickHandler: () => this.addAgain(this.selectedProduct.skuId),
    };
    const trackInfo = this.props.trackOrderInfo;
    const trackOrderURL =
      trackInfo &&
      trackInfo.orderTrackInfo &&
      trackInfo.orderTrackInfo.tplRedirectionURL &&
      trackInfo.orderTrackInfo.trackingNumber
        ? trackInfo.orderTrackInfo.tplRedirectionURL +
          trackInfo.orderTrackInfo.trackingNumber
        : "";
    if (
      trackInfo &&
      trackInfo.orderTrackInfo &&
      trackInfo.orderTrackInfo.stageLevel
    ) {
      if (trackInfo.orderTrackInfo.stageLevel === "Stage1") {
        this.progressBar = 1;
        this.stage1class = "titleGreenOrder";
      } else if (trackInfo.orderTrackInfo.stageLevel === "Stage2") {
        this.progressBar = 2;
        this.stage1class = "titleGreenOrder";
        this.stage2class = "titleGreenOrder";
      } else if (trackInfo.orderTrackInfo.stageLevel === "Stage3") {
        this.progressBar = 3;
        this.stage1class = "titleGreenOrder";
        this.stage2class = "titleGreenOrder";
        this.stage3class = "titleGreenOrder";
      } else {
        this.progressBar = 4;
        this.stage1class = "titleGreenOrder";
        this.stage2class = "titleGreenOrder";
        this.stage3class = "titleGreenOrder";
        this.stage4class = "titleGreenOrder";
      }
    }

    return (
      <React.Fragment>
        <div className="home-container">
          <table className="tableDetailProduct">
            <tbody>
              <tr>
                <td>
                  <p className="content">{this.selectedProduct.displayName}</p>
                  <p className="content">
                    {commonUtil.getLabel(
                      lables.EventAdminPage,
                      "adminpage.regalosrecibidos.sku.by.label"
                    )}
                    :{" "}
                    <span className="secondaryContent">
                      {this.selectedProduct.skuId}
                    </span>
                  </p>
                </td>
              </tr>
              <tr>
                <td>
                  <p className="content">
                    {commonUtil.getLabel(
                      lables.EventAdminPage,
                      "adminpage.regalosrecibidos.delivery.address.invited.label"
                    )}
                    :{" "}
                    <span className="secondaryContent">
                      {this.selectedProduct && this.selectedProduct.guestInfo
                        ? this.selectedProduct.guestInfo.name
                        : null}
                    </span>
                  </p>
                </td>
              </tr>
              <tr>
                <td>
                  <p className="content">
                    {commonUtil.getLabel(
                      lables.EventAdminPage,
                      "adminpage.regalosrecibidos.date.label"
                    )}
                    :{" "}
                    <span className="secondaryContent">
                      {this.selectedProduct && this.selectedProduct.guestInfo
                        ? this.selectedProduct.guestInfo.dateofPurchase
                        : null}
                    </span>
                  </p>
                </td>
              </tr>

              <tr>
                <td>
                  <p className="content">
                    {commonUtil.getLabel(
                      lables.EventAdminPage,
                      "adminpage.regalosrecibidos.warehouse.label"
                    )}
                    :{" "}
                    <span className="secondaryContent">
                      {this.selectedProduct && this.selectedProduct.guestInfo
                        ? this.selectedProduct.guestInfo.popupStore
                        : null}
                    </span>
                  </p>
                </td>
              </tr>
              <tr>
                <td>
                  <p className="content">
                    {commonUtil.getLabel(
                      lables.EventAdminPage,
                      "adminpage.regalosrecibidos.delivery.address.label"
                    )}
                    :{" "}
                    <span className="secondaryContent">
                      {this.selectedProduct &&
                      this.selectedProduct.guestInfo &&
                      this.selectedProduct.modeofDelivery === "physical"
                        ? this.selectedProduct.guestInfo.popupDelivery
                        : "-"}
                    </span>
                  </p>
                </td>
              </tr>
              <tr>
                <td>
                  {this.props.compareEventStatus(
                    this.selectedProduct.deliveryStatus,
                    "Estatus de entrega"
                  ) ? (
                    <p className="content">
                      {commonUtil.getLabel(
                        lables.EventAdminPage,
                        "adminpage.regalosrecibidos.delivery.tracking.label"
                      )}
                      :{modalButton}{" "}
                    </p>
                  ) : (
                    <React.Fragment>
                      {this.props.compareEventStatus(
                        this.selectedProduct.deliveryStatus,
                        "Regalo electronico"
                      ) ||
                      this.props.compareEventStatus(
                        this.selectedProduct.deliveryStatus,
                        "Entregado en tienda"
                      ) ? (
                        <span className="status txt-deco-none">
                          {this.selectedProduct.deliveryStatus}
                        </span>
                      ) : (
                        <span className="secondaryContent">
                          {this.selectedProduct.deliveryStatus}
                        </span>
                      )}
                    </React.Fragment>
                  )}
                </td>
              </tr>
              <tr>
                {!this.props.compareEventStatus(
                  this.props.eventType,
                  eventTypes
                ) ? (
                  <td>
                    <p className="content">
                      {commonUtil.getLabel(
                        lables.EventAdminPage,
                        "adminpage.regalosrecibidos.bonus.label"
                      )}
                      :&nbsp;
                      {this.selectedProduct.bonusInfo === "true" ? (
                        <i
                          className="icon-check confirmCheck"
                          aria-hidden="true"
                        />
                      ) : (
                        <i
                          className="icon-tache disableCheck"
                          aria-hidden="true"
                        />
                      )}
                    </p>
                    {this.selectedProduct.bonusInfo === "false" ? (
                      <p className="secondaryContent">
                        {this.selectedProduct.bonusMessage}
                      </p>
                    ) : null}
                  </td>
                ) : (
                  ""
                )}
              </tr>
              <tr>
                <td>
                  <p className="content">
                    {commonUtil.getLabel(
                      lables.EventAdminPage,
                      "adminpage.regalosrecibidos.gift.for.label"
                    )}{" "}
                    :{" "}
                    <span className="secondaryContent">
                      {this.selectedProduct && this.selectedProduct.guestInfo
                        ? this.selectedProduct.guestInfo.popupOwner
                        : null}
                    </span>
                  </p>
                </td>
              </tr>
            </tbody>
          </table>
          {this.selectedProduct.messageInfo === "replied" ? (
            <div>
              <div className="grayContent float-none">
                <h4>
                  {commonUtil.getLabel(
                    lables.EventAdminPage,
                    "adminpage.regalosrecibidos.thankyoumsg.label"
                  )}
                  :
                </h4>
                <p>
                  {this.props.messages && this.props.messages.customerMsg
                    ? this.props.messages.customerMsg
                    : null}
                </p>
              </div>
              {this.props.messages && this.props.messages.customMsg !== "" ? (
                <div className="grayContent float-none">
                  <h4>
                    {commonUtil.getLabel(
                      lables.EventAdminPage,
                      "adminpage.regalosrecibidos.message.label"
                    )}
                    :
                  </h4>
                  <p>
                    {this.props.messages && this.props.messages.customMsg
                      ? this.props.messages.customMsg
                      : null}
                  </p>
                </div>
              ) : null}
            </div>
          ) : null}
          {this.selectedProduct.messageInfo === "new" ||
          this.selectedProduct.messageInfo === "opened" ? (
            <div className="grayContent float-none">
              <h4>
                {commonUtil.getLabel(
                  lables.EventAdminPage,
                  "adminpage.regalosrecibidos.message.label"
                )}
                :
              </h4>
              <p>
                {this.props.messages && this.props.messages.customMsg
                  ? this.props.messages.customMsg
                  : null}
              </p>
            </div>
          ) : null}

          {this.selectedProduct.messageInfo === "new" ||
          this.selectedProduct.messageInfo === "opened" ||
          this.selectedProduct.messageInfo === "none"
            ? modalDataForSendMessage
            : null}
          <Warning
            type="success"
            text={this.warningMessage}
            ref={(warning) => (this.warning = warning)}
            notSetToTop="true"
          />
          <Warning
            type="error"
            text={this.errorMessage}
            ref={(errorMessage) => (this.errorMessage = errorMessage)}
            notSetToTop="true"
          />
          {this.props.compareEventStatus(
            this.props.eventStatus,
            defaultConst.eventStatus.ACTIVE
          ) ? (
            <div className="addAgain">
              <Link linkJSON={LinkJSON}>{LinkJSON.displayName}</Link>
            </div>
          ) : (
            <div className="addAgain">
              {commonUtil.getLabel(
                lables.EventAdminPage,
                "adminpage.regalosrecibidos.addagain.label"
              )}
            </div>
          )}
        </div>
        {/* Modal for tracker */}
        <ModalPopover
          headerData={modalHeaderForTracker}
          ref={(trackingModal) => (this.trackingModal = trackingModal)}
          modalId="tracingModal"
          isModal="true"
          dismiss="false"
        >
          <div className="row grayContent productDet">
            <div className="col-xs-12">
              <div className="col-xs-4">
                <div className="imgProduct">
                  <Image
                    imageAttr={imageAttrTracker}
                    _imgsrc={_imgsrcTracker}
                  />
                </div>
              </div>
              <div className="col-xs-8">
                <p className="nameProduct textToBold">
                  {trackInfo &&
                  trackInfo.orderTrackInfo &&
                  trackInfo.orderTrackInfo.productName
                    ? trackInfo.orderTrackInfo.productName
                    : this.selectedProduct.displayName}
                </p>
                <p>
                  {commonUtil.getLabel(
                    lables.EventAdminPage,
                    "adminpage.regalosrecibidos.qty.label"
                  )}
                  :{" "}
                  {trackInfo &&
                  trackInfo.orderTrackInfo &&
                  trackInfo.orderTrackInfo.quantity
                    ? parseInt(trackInfo.orderTrackInfo.quantity, 10)
                    : this.selectedProduct.quantity}
                </p>
                <p className="dateTitle">
                  {commonUtil.getLabel(
                    lables.EventAdminPage,
                    "adminpage.regalosrecibidos.deadline.label"
                  )}
                  :
                </p>
                <p className="dateDeliver">
                  {trackInfo &&
                  trackInfo.orderTrackInfo &&
                  trackInfo.orderTrackInfo.estimatedDeliveryDate
                    ? commonUtil.formatDate(
                        commonUtil.formatServiceDate(
                          trackInfo.orderTrackInfo.estimatedDeliveryDate
                        ),
                        "monthName"
                      )
                    : ""}
                </p>
              </div>
            </div>
          </div>
          <div className="row grayContent pt10">
            <div className="col-xs-2" style={{ display: "inline-block" }}>
              <div className="col-xs-2">
                <ProgressBar
                  percent={50}
                  width={20}
                  stages={4}
                  channel="wap"
                  completedStages={this.progressBar}
                />
              </div>
            </div>
            <div className="col-xs-10" style={{ display: "inline-block" }}>
              <ul className="progressDeliver">
                <li>
                  <p className={this.stage1class}>
                    {trackInfo &&
                    trackInfo.orderTrackInfo &&
                    trackInfo.orderTrackInfo.stage1Status
                      ? trackInfo.orderTrackInfo.stage1Status
                      : ""}
                  </p>
                  <p className="subOrder">
                    {trackInfo &&
                    trackInfo.orderTrackInfo &&
                    trackInfo.orderTrackInfo.stage1Date ? (
                      trackInfo.orderTrackInfo.stage1Date
                    ) : (
                      <br />
                    )}
                  </p>
                </li>
                <li>
                  <p className={this.stage2class}>
                    {trackInfo &&
                    trackInfo.orderTrackInfo &&
                    trackInfo.orderTrackInfo.stage2Status
                      ? trackInfo.orderTrackInfo.stage2Status
                      : ""}
                  </p>
                  <p className="subOrder">
                    {trackInfo &&
                    trackInfo.orderTrackInfo &&
                    trackInfo.orderTrackInfo.stage2Date ? (
                      trackInfo.orderTrackInfo.stage2Date
                    ) : (
                      <br />
                    )}
                  </p>
                </li>
                <li>
                  <p className={this.stage3class}>
                    {trackInfo &&
                    trackInfo.orderTrackInfo &&
                    trackInfo.orderTrackInfo.stage3Status
                      ? trackInfo.orderTrackInfo.stage3Status
                      : ""}
                  </p>
                  <p className="subOrder">
                    {trackInfo &&
                    trackInfo.orderTrackInfo &&
                    trackInfo.orderTrackInfo.stage3Date ? (
                      trackInfo.orderTrackInfo.stage3Date
                    ) : (
                      <br />
                    )}
                  </p>
                </li>
                <li>
                  <p className={this.stage4class}>
                    {trackInfo &&
                    trackInfo.orderTrackInfo &&
                    trackInfo.orderTrackInfo.stage4Status
                      ? trackInfo.orderTrackInfo.stage4Status
                      : ""}
                  </p>
                  <p className="subOrder">
                    {trackInfo &&
                    trackInfo.orderTrackInfo &&
                    trackInfo.orderTrackInfo.stage4Date ? (
                      trackInfo.orderTrackInfo.stage4Date
                    ) : (
                      <br />
                    )}
                  </p>
                </li>
              </ul>
            </div>
          </div>
          {trackInfo &&
          trackInfo.orderTrackInfo &&
          trackInfo.orderTrackInfo.trackingNumber !== "" ? (
            <div className="col-md-12 col-sm-12 footerTlo">
              <p className="text-right">
                {commonUtil.getLabel(
                  lables.EventAdminPage,
                  "adminpage.regalosrecibidos.shipping.dhl.by.label"
                )}{" "}
                -{" "}
                <span>
                  {commonUtil.getLabel(
                    lables.EventAdminPage,
                    "adminpage.regalosrecibidos.guide.number.by.label"
                  )}
                  :{" "}
                  <a href={trackOrderURL}>
                    {trackInfo &&
                    trackInfo.orderTrackInfo &&
                    trackInfo.orderTrackInfo.trackingNumber
                      ? trackInfo.orderTrackInfo.trackingNumber
                      : ""}
                  </a>
                </span>
              </p>
            </div>
          ) : null}
        </ModalPopover>

        <ModalPopover
          modalId="sharingModal"
          isModal="true"
          modalClass="confirmationModalPopup"
          ref={(trackingFailureModal) =>
            (this.trackingFailureModal = trackingFailureModal)
          }
          handleOutsideClick
        >
          <div className="row text-align-center">
            <div className="col-xs-12">
              <p>
                {commonUtil.getLabel(
                  lables.EventAdminPage,
                  "adminpage.recibidos.track.order.failure.message"
                )}
              </p>
            </div>
            <div className="col-xs-12">
              <div className="modal-btn-container">
                <div className="pt10 pb10">
                  <a
                    className="btn-link"
                    value="accept"
                    onClick={this.confirmAction}
                  >
                    OK
                  </a>
                </div>
              </div>
            </div>
          </div>
        </ModalPopover>

        {/* Send Message Pop-up */}
        <ModalPopover
          headerData={modalHeaderForSendMessage}
          ref={(sendMessageModal) => (this.sendMessageModal = sendMessageModal)}
          modalId="messageModal"
          isModal="true"
          dismiss="false"
        >
          {/* <hr className="divider" /> */}
          <div className="row">
            <div className="col-xs-12">
              <form id="formMsg" noValidate="novalidate">
                {this.selectedProduct.messageInfo === "none" ||
                ((this.selectedProduct.messageInfo === "new" ||
                  this.selectedProduct.messageInfo === "opened") &&
                  (!this?.props?.messages?.guestEmail ||
                    this?.props?.messages?.guestEmail === null)) ? (
                  // <div className="container">

                  <React.Fragment>
                    {/* <div className="row">
                      <div className="col-xs-4 col-lg-3" />
                      <div className="col-xs-8 col-lg-9">
                        <p className="trr">{commonUtil.getLabel(lables.EventAdminPage, 'adminpage.regalosrecibidos.msg.requirefields')}</p>
                      </div>
                    </div> */}

                    <div className="form-group">
                      <div className="materialStyle">
                        <input
                          className="inputMaterial"
                          type="text"
                          name="guestName"
                          required="required"
                          id="guestname"
                        />
                        <label className="placeHolderMaterial">
                          <span>*</span>
                          {commonUtil.getLabel(
                            lables.EventAdminPage,
                            "adminpage.regalosrecibidos.msg.guestname"
                          )}
                        </label>
                      </div>
                    </div>

                    <div className="form-group">
                      <div className="materialStyle">
                        <input
                          className="inputMaterial"
                          type="text"
                          name="guestEmail"
                          required="required"
                          id="guestemail"
                        />
                        <label className="placeHolderMaterial">
                          <span>*</span>
                          {commonUtil.getLabel(
                            lables.EventAdminPage,
                            "adminpage.regalosrecibidos.msg.guestemail"
                          )}
                        </label>
                      </div>
                    </div>
                  </React.Fragment>
                ) : null}

                <div className="form-group">
                  <textarea
                    className="form-control"
                    placeholder="Escribe tu mensaje ..."
                    rows={10}
                    defaultValue={""}
                    id="sendMessage"
                    onKeyUp={(e) => this.messageLengthValidation(e)}
                    maxLength={300}
                  />
                </div>
                {/* maxLength={5} */}
                <InputButton buttonAttr={SendThankYouMessage} />
              </form>
            </div>
          </div>
        </ModalPopover>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  messages: state.giftList.data.messageInfo,
  messageLoaded: state.giftList.messageLoaded,
  eventStatus:
    state.giftList &&
    state.giftList.data &&
    state.giftList.data.eventSummaryInfo &&
    state.giftList.data.eventSummaryInfo.eventInfo &&
    state.giftList.data.eventSummaryInfo.eventInfo.eventStatus,
  trackOrderInfo: state.giftList.data.trackOrderInfo,
  eventType:
    state.giftList &&
    state.giftList.data &&
    state.giftList.data.eventSummaryInfo &&
    state.giftList.data.eventSummaryInfo.eventInfo &&
    state.giftList.data.eventSummaryInfo.eventInfo.eventType,
});
const matchDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      addAgainGiftItem,
      getMessagesService,
      getTrackOrder,
      getRegisteredGiftList,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  matchDispatchToProps
)(ProductDetailsRecibidos);
